// Plan IDs match the rows in the backend `plans` table. Slugs are the
// canonical string identifier used across BE and FE.
//
// Plus rows (1, 2) are grandfathered: existing subscribers keep billing,
// but new purchases are blocked in the paywall and on Stripe.
// LEGACY_FREE_TRIAL (6) is deprecated; current users are moved to FREE at launch.
export const PLAN_IDS = {
  PLUS_MONTHLY: 1,
  PLUS_YEARLY: 2,
  PRO_MONTHLY: 3,
  PRO_YEARLY: 4,
  FREE: 5,
  LEGACY_FREE_TRIAL: 6,
  PRO_TRIAL: 7,
  PRO_NEWSLETTER_MONTHLY: 8,
  PRO_NEWSLETTER_YEARLY: 9,
};

export const PLAN_SLUGS = {
  PLUS: "plus",
  PRO: "pro",
  FREE: "free",
  LEGACY_FREE_TRIAL: "free-trial",
  PRO_TRIAL: "pro-trial",
  PRO_NEWSLETTER: "pro-newsletter",
};

export const PAID_PLAN_SLUGS = [
  PLAN_SLUGS.PLUS,
  PLAN_SLUGS.PRO,
  PLAN_SLUGS.PRO_TRIAL,
  PLAN_SLUGS.PRO_NEWSLETTER,
  // Keep LEGACY_FREE_TRIAL while any plan_id=6 users still exist. The daily
  // checkExpiredPlans cron naturally downgrades them to Free within 3 days
  // of their signup, so this entry can be removed once the table is empty
  // (~3 days after Phase 2a deploys to prod).
  PLAN_SLUGS.LEGACY_FREE_TRIAL,
];

export const GRANDFATHERED_PLAN_IDS = [
  PLAN_IDS.PLUS_MONTHLY,
  PLAN_IDS.PLUS_YEARLY,
];

export const isPaidPlan = (slug) => PAID_PLAN_SLUGS.includes(slug);

export const isGrandfatheredPlus = (planId) =>
  GRANDFATHERED_PLAN_IDS.includes(Number(planId));
